/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Empty_TitleInputs */

const en_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tracked jobs yet`)
};

const de_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keine getrackten Jobs`)
};

const fr_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pas encore d'emplois suivis`)
};

const es_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin empleos registrados aun`)
};

const it_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun lavoro monitorato`)
};

const nl_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nog geen gevolgde banen`)
};

const pl_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brak sledzonych ofert pracy`)
};

const fi_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ei seurattuja työpaikkoja vielä`)
};

const da_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen sporede jobs endnu`)
};

const sv_interview_empty_title = /** @type {(inputs: Interview_Empty_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga foljda jobb annu`)
};

/**
* | output |
* | --- |
* | "No tracked jobs yet" |
*
* @param {Interview_Empty_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_empty_title = /** @type {((inputs?: Interview_Empty_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Empty_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_empty_title(inputs)
	if (locale === "fr") return fr_interview_empty_title(inputs)
	if (locale === "es") return es_interview_empty_title(inputs)
	if (locale === "it") return it_interview_empty_title(inputs)
	if (locale === "nl") return nl_interview_empty_title(inputs)
	if (locale === "pl") return pl_interview_empty_title(inputs)
	if (locale === "fi") return fi_interview_empty_title(inputs)
	if (locale === "da") return da_interview_empty_title(inputs)
	if (locale === "sv") return sv_interview_empty_title(inputs)
	return en_interview_empty_title(inputs)
});